import { useEffect } from "react";
import RestaurantDescription from "./components/restaurantDescription";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Link,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import OpeningHoursPopover from "./components/openingHoursPopover";
import PageList from "./components/pageList";
import ScrollToTop from "./components/scrollToTop";
import { fetchStore } from "./modules/store/actions";
import Checkout from "./routes/checkout";
import Frontpage from "./routes/frontpage";
import Order from "./routes/order";
import Page from "./routes/page";
import Regulations from "./routes/regulations";
import PrivacyPolicy from "./routes/privacyPolicy";
import PickupOrder from "./routes/pickupOrder";
import { Button, Header, Logo, LogoLink, PhoneLink } from "./styles";
import Modal from "./components/modal";
import { useNote } from "./hooks";
import StoreUnavailable from "./components/storeUnavailable";

function App() {
  const store = useSelector((state) => state.store);
  const { note, isSeen: noteIsSeen, acknowledge } = useNote();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title =
      store.status === "notFound"
        ? "Nie znaleziono restauracji · eatally"
        : store.name || "eatally";
  }, [store.name, store.status]);

  useEffect(() => {
    dispatch(fetchStore());
  }, [dispatch]);

  if (store.status === "idle" || store.status === "loading") {
    return (
      <main className="store-loading" aria-busy="true">
        <span className="visually-hidden" role="status">
          Ładowanie restauracji…
        </span>
      </main>
    );
  }

  if (store.status === "notFound" || store.status === "error") {
    return (
      <StoreUnavailable
        notFound={store.status === "notFound"}
        onRetry={() => dispatch(fetchStore())}
      />
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <Header />
      <Container className="app-shell mb-4">
        <header className="app-header">
          <div className="app-header-row">
            <div className="app-identity">
              <LogoLink as={Link} to="/" aria-label="Przejdź do menu">
                <Logo bgImage={store.logo} />
              </LogoLink>
              <div className="app-identity-copy">
                <h1 className="brand-name">{store.name}</h1>
                <PhoneLink href={`tel:${store.phone}`}>
                  tel. {store.phone}
                </PhoneLink>
              </div>
            </div>
            <PageList>
              <OpeningHoursPopover />
            </PageList>
          </div>
          {store.description && (
            <RestaurantDescription>{store.description}</RestaurantDescription>
          )}
        </header>
        <div className="app-content">
          <Switch>
            <Route exact path="/">
              <Frontpage />
            </Route>
            <Route exact path="/o/:hash">
              <PickupOrder />
            </Route>
            <Route path="/checkout">
              <Checkout />
            </Route>
            <Route path="/order/:hashid">
              <Order />
            </Route>
            <Route path="/page/:slug">
              <Page />
            </Route>
            <Route exact path="/regulamin">
              <Regulations />
            </Route>
            <Route exact path="/polityka-prywatnosci">
              <PrivacyPolicy />
            </Route>
            <Route path="*">
              <Redirect to="/" replace />
            </Route>
          </Switch>
        </div>
        <footer className="brand-footer">
          <nav className="brand-footer__legal" aria-label="Dokumenty prawne">
            <Link to="/regulamin">Regulamin</Link>
            <Link to="/polityka-prywatnosci">Polityka prywatności</Link>
          </nav>
          <span className="text-end">Strona dostępna dzięki</span>
          <a
            className="brand-footer__mark"
            href="https://eatally.pl"
            target="_blank"
            rel="noopener noreferrer"
          >
            eatally
          </a>
        </footer>
      </Container>
      <Modal open={!noteIsSeen && note.length > 0}>
        <div className="text-center">
          <div style={{ whiteSpace: "pre-wrap" }}>{note}</div>
          <Button className="mt-4" onClick={acknowledge}>
            Ok, zamknij
          </Button>
        </div>
      </Modal>
    </Router>
  );
}

export default App;
